// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"673":"ppme-shared","897":"ppme-settings"}[chunkId] || chunkId) + ".css";
};